module.exports = __webpack_public_path__ + "static/media/overflow.646c76ab.svg";